import { IResource } from "@gettactic/api";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { HookFormToggleInput } from "@cmp-src/form/ToggleInput";

export interface ResourceMakeUnavailableControlProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  entity: string;
  resource: IResource | null;
}

export function ResourceMakeUnavailableControl<T extends FieldValues>({
  form,
  name,
  entity,
  resource
}: ResourceMakeUnavailableControlProps<T>) {
  return (
    <div className="mt-5">
      <HookFormToggleInput
        form={form}
        name={name}
        label="Make unavailable"
        description={
          entity === "zone"
            ? `When enabled, no new reservations can be made for workspaces belonging to ${resource?.name || "this zone"}.`
            : `When enabled, no new reservations can be made for ${resource?.name || "this workspace"}.`
        }
        togglePosition="right"
        colorVariant="destructive"
      />
    </div>
  );
}
